import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('LadProvider', LadProviderData);

    LadProviderData.$inject = ['$translate', 'logger'];

    /* @ngInject */
    function LadProviderData($translate, logger) {
        LadProvider.prototype = {
            build: build,
            buildEmpty: buildEmpty
        };

        function LadProvider(ladProviderData) {
            if (!ladProviderData) {
                this.buildEmpty();
            } else {
                this.build(ladProviderData);
            }
        }

        return LadProvider;

        /////////////////////

        function buildEmpty() {
            this.eId = null;
            this.name = null;
            this.kind = 'EXTERNAL';
            this.selectable = true;
            this.containerModeRestriction = null;
        }

        function build(ladProviderData) {
            if (ladProviderData) {
                this.eId = ladProviderData.eId || null;
                this.name = ladProviderData.name || null;
                this.kind = ladProviderData.kind || 'EXTERNAL';
                this.selectable = !!ladProviderData.selectable;
                this.containerModeRestriction = ladProviderData.containerModeRestriction || null;
            } else {
                logger.error('Error with ladProvider', ladProviderData);
            }
        }
    }
})();
